import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';

const CustomInput = ({
  type,
  value,
  onChange,
  options,
  label,
  defaultValue,
  colSize,
  disabled,
  ...props
}) => {
  return (
    <FormGroup>
      <Label>{label}</Label>
      {type === 'select' ? (
        <Input
          type="select"
          value={value || defaultValue}
          onChange={onChange}
          disabled={disabled}
          {...props}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      ) : (
        <Input
          type={type}
          value={value || defaultValue}
          onChange={onChange}
          {...props}
          disabled={disabled}
        />
      )}
    </FormGroup>
  );
};

CustomInput.propTypes = {
  disabled: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colSize: PropTypes.number,
};

CustomInput.defaultProps = {
  type: 'text',
  options: [],
  defaultValue: '',
  colSize: 6,
};

export default CustomInput;
